import React, { useState } from "react";

import { LivePanel } from "@demo/ui/LivePanel.js";
import { ContentCredential } from "@demo/ui/ContentCredential.js";
import { NEWSROOM_GIG_CATALOG } from "@demo/live/gig-catalog-newsroom.js";
import { CLARION } from "./scenario/clarion.js";
import { NEWSROOM_BUNDLES } from "./data.js";

// The Clarion app leads with an Overview — a published story with a verifiable
// content credential, a distinct layout from the other demos — with the live
// seal behind a second tab. Everything below the masthead is shared UI driven
// by Clarion's copy; the recorded receipts the Overview verifies are two real
// content-provenance credentials (apps/newsroom-demo/src/data.ts).
type Mode = "overview" | "live";

export function App() {
  const [mode, setMode] = useState<Mode>("overview");

  return (
    <div className="page">
      <div className="disclosure-banner" role="note">
        <span className="disclosure-dot" aria-hidden="true" />
        <span>{CLARION.disclosure}</span>
      </div>

      <header className="masthead">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            {CLARION.client.mark}
          </span>
          <div>
            <div className="brand-name">{CLARION.client.name}</div>
            <div className="brand-domain">{CLARION.client.domain}</div>
          </div>
        </div>
        <div className="masthead-tag">{CLARION.masthead}</div>
      </header>

      <div className="mode-toggle" role="tablist" aria-label="Demo section">
        <button
          role="tab"
          aria-selected={mode === "overview"}
          className={"mode-toggle-btn" + (mode === "overview" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("overview")}
        >
          Overview
        </button>
        <button
          role="tab"
          aria-selected={mode === "live"}
          className={"mode-toggle-btn" + (mode === "live" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("live")}
        >
          Run live
        </button>
      </div>

      {mode === "overview" ? (
        <main className="content">
          <ContentCredential
            config={CLARION.credential}
            bundles={NEWSROOM_BUNDLES}
            ctas={[{ ...CLARION.liveCta, onClick: () => setMode("live") }]}
          />
        </main>
      ) : (
        <main className="content">
          <section className="intro">
            <h1>{CLARION.intro.headline}</h1>
            <p>{CLARION.intro.body}</p>
          </section>

          <LivePanel catalog={NEWSROOM_GIG_CATALOG} copy={CLARION.live} />
        </main>
      )}

      <footer className="footer">
        <p>
          {CLARION.disclosure} Built on <span className="footer-link">{CLARION.product.name}</span>:{" "}
          {CLARION.product.tagline}.
        </p>
      </footer>
    </div>
  );
}
